/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponse
 */
export interface WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponse
     */
    reference?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponse
     */
    referenceType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponse
     */
    url?: string | null;
}

/**
 * Check if a given object implements the WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponse interface.
 */
export function instanceOfWebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponseFromJSON(json: any): WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponse {
    return WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponseFromJSONTyped(json, false);
}

export function WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reference': !exists(json, 'reference') ? undefined : json['reference'],
        'referenceType': !exists(json, 'reference_type') ? undefined : json['reference_type'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponseToJSON(value?: WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reference': value.reference,
        'reference_type': value.referenceType,
        'url': value.url,
    };
}

